import React, { forwardRef, useImperativeHandle, useRef, useState } from "react";
import { RCCRefModalProps } from "react-common-components";
import Modal from "src/components/Modal";
import { useTranslation } from "src/context/Translations/context";
import HierarchyFinancialManagementSubsidiaryAndStatementLinesIndicators from "src/pages/FinancialManagement/components/HierarchySubsidiaryAndStatementLinesIndicators";
import { IModalManageIndicator, IRefModalManageIndicator } from "./interface";

const ModalManageIndicator: React.ForwardRefRenderFunction<IRefModalManageIndicator, IModalManageIndicator> = ({
	budgetPlanId
},ref) => {
	const { translate } = useTranslation();

	// Modal values
	const [subtitle, setSubtitle] = useState("");
	const [ofm002Id, setOfm002Id] = useState(0);
	const modalManageIndicators = useRef<RCCRefModalProps>(null);

	const actionButtonManageIndicators = async (id: number, name: string) => {
		setOfm002Id(id);
		setSubtitle(`${translate("Indicadores")} ${translate("de")}: ${name}`);
		modalManageIndicators.current?.openModal();
	};

	useImperativeHandle(ref, () => ({
		actionButtonManageIndicators
	}));

	return (
		<Modal
			ref={modalManageIndicators}
			header={{
				title: translate("Gerenciar indicadores"),
				subtitle,
				icon: {
					name: "chartBar"
				}
			}}
			footer={{
				buttonLoadingText: translate("Carregando"),
				saveButtonText: translate("Salvar"),
				cancelButtonText: translate("Cancelar"),
				showSaveButton: false
			}}
			withoutForm
		>
			<HierarchyFinancialManagementSubsidiaryAndStatementLinesIndicators 
				ofa001Id={budgetPlanId}
				ofm002Id={ofm002Id}
			/>
		</Modal>
	);
};

export default forwardRef(ModalManageIndicator);
